import { applicationApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const RATE_SHEET_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/rateSheets`,
  {
    GET_RATE_SHEETS: 'GET_RATE_SHEETS',
  },
);

const rateSheetsSchema = new schema.Entity('data', {}, { idAttribute: 'rateSheetId' });

export const getLoanRateSheetsAction = catchAsyncActionError(({ loanId }) => async dispatch => {
  const { data } = await applicationApi.getRateSheets({ loanId });

  return dispatch({
    type: RATE_SHEET_ACTION_TYPE.GET_RATE_SHEETS,
    payload: normalize(data, [rateSheetsSchema]).entities.data,
  });
});
